import React, { useMemo, useState } from 'react';
import { Col, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react'
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import paths from 'routes/paths';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import moment from 'moment';
import { prescriptionType } from './prescriptionType.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RefillDiscontinuedModal from './RefillDiscontinuedModal.js';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from 'helpers/api';
import { ACCESS_CONTROL } from 'components/authentication/accessControlMap.js';
import AdvanceTableCurrentPresc from 'components/common/advance-table/AdvanceTableCurrentPresc.js';
import IframeContainerDrug from 'components/navbar/top/IframeContainerDrug.js';
import DiscontinuePrescriptionModal from './DiscontinuePrescriptionModal.js';
import { faHospital } from '@fortawesome/free-solid-svg-icons';



const CurrentPrescription = (props) => {
    //const [facility] = useState(facilityStaffData);
    const [theme, setTheme] = useState(document.documentElement.getAttribute('data-bs-theme') || 'light');
    const [currentPrescription, setCurrentPrescription] = useState([]);
    const [prescriptionTypeOptions, setprescriptionTypeOptions] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedDrugId, setSelectedDrugId] = useState(null);
    const [iframeKey, setIframeKey] = useState(0);
    const [show, setShow] = useState(false);
    const [legendCounts, setLegendCounts] = useState({
        active: 0,
        unverified: 0,
        discontinued: 0,
        discontinuedLast24h: 0,
        unverifiedLast2Days: 0,
        discontinuedLast2Days: 0
    });
    const location = useLocation();
    const searchParams = useMemo(
        () => new URLSearchParams(location.search),
        [location.search]
    );
    const action = searchParams.get('action');
    const [selectedType, setSelectedType] = useState(action == "discontinued" ? 'discontinued' : 'active');
    const data = props?.data;
    let roleId = Number(localStorage.getItem("roleId"))
    let localStorageAccessControl = localStorage.getItem("accessControl");
    if (localStorageAccessControl === null) {
        localStorageAccessControl = [];
    } else {
        localStorageAccessControl = localStorageAccessControl.split(",");
    }

    const discontinueColumn = {
        accessorKey: 'discontinue',
        header: 'Disc Order',
        meta: {
            headerProps: { className: 'text-900 text-start' }
        },
        cell: ({ row: { original } }) => {
            return (
                <>
                    {original.discontinued_date == null && (
                        <Link className="p-2" onClick={() => {
                            setSelectedDrugId(null);
                            setShow(true);
                        }} state={{ original }}>
                            <FontAwesomeIcon icon="plus" className="me-1 fs-11" />
                        </Link>
                    )}
                </>
            );
        }
    };

    const columns = [
        {
            accessorKey: 'orderid',
            header: 'Id',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            },
            cell: ({ row: { original } }) => {
                const editPrescription = paths.editPrescription;
                const showIcon = original.from_ips == 0;

                const badges = (
                    <span style={{ gap: "5px", display: "inline-flex" }} className='ms-1'>
                        {original.is_fnto == 1 && (
                            <span style={{ background: "#ffcc80", color: "#8a4500", padding: "2px 6px", borderRadius: "6px", fontWeight: "600", fontSize: "10px" }}>
                                FOTN
                            </span>
                        )}
                        {original.is_new == 1 && original.is_fnto == 0 && (
                            <span style={{ background: "#e0e0e0", color: "#333", padding: "2px 6px", borderRadius: "6px", fontWeight: "600", fontSize: "10px" }}>
                                New 
                            </span>
                        )}
                        {/* {original.isExpired && (
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id="tooltip-expired">
                                        Expired on {moment(original.client_stopdate).format("MM/DD/YY")}
                                    </Tooltip>
                                }
                            >
                                <span style={{ background: "#ffcc80", color: "#8a4500", padding: "3px 4px", borderRadius: "6px", fontWeight: "600", fontSize: "10px" }}>
                                    <FontAwesomeIcon icon="exclamation-triangle" />
                                </span>
                            </OverlayTrigger>
                        )} */}
                        {original.expiryStatus && (
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id="tooltip-expired">
                                        {original.expiryStatus.type === 'expired'
                                            ? `Expired on ${moment(original.pharmacy_expire_date ).format("MM/DD/YY")}`
                                            : `Expiring in ${original.expiryStatus.daysLeft} day${original.expiryStatus.daysLeft !== 1 ? 's' : ''}`
                                        }
                                    </Tooltip>
                                }
                            >
                                <span style={{ background: "#ffcc80", color: "#8a4500", padding: "3px 4px", borderRadius: "6px", fontWeight: "600", fontSize: "10px" }}>
                                    <FontAwesomeIcon icon="exclamation-triangle" />
                                </span>
                            </OverlayTrigger>
                        )}
                    </span>
                );

                const tooltip = (
                    <Tooltip id={`tooltip-hospital-${original.orderid}`}>
                        Prescription created by Facility
                    </Tooltip>
                );

                const contentWithTooltip = (
                    <OverlayTrigger
                        overlay={tooltip}
                        placement="top"
                        containerPadding={10}
                        popperConfig={{
                            modifiers: [{ name: 'zIndex', enabled: true, phase: 'write', fn({ state }) { state.styles.popper.zIndex = 9999; } }]
                        }}
                    >
                        <span tabIndex="0" className="d-inline-block text-decoration-underline text-primary">
                            {original.orderid}
                            {showIcon && <FontAwesomeIcon icon={faHospital} className="ms-1 text-info" />}
                        </span>
                    </OverlayTrigger>
                );

                return localStorageAccessControl.includes(String(ACCESS_CONTROL["editprescription"])) && (roleId < 7) ? (
                    <Link
                        to={{
                            pathname: `${editPrescription}/${original.orderid}`,
                        }}
                        state={{
                            from_ips: data.from_ips,
                            orderid: original.orderid,
                            patientid: original.patientid,
                            facilityid: original.facility_id
                        }}
                        className="text-decoration-none"
                    >
                        {showIcon ? contentWithTooltip : <span>{original.orderid} {badges}</span>}
                    </Link>
                ) : (
                    showIcon ? contentWithTooltip :( <><span>{original.orderid} {badges}</span></> )
                );
            }
        },
        {
            accessorKey: 'drug',
            header: 'Drug',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            },
            cell: ({ row: { original } }) => (
                <div>
                    <span
                        className="text-primary cursor-pointer text-decoration-underline"
                        role="button"
                        onClick={() => handleDrugClick(original.orderid)}
                    >
                        {original.drugText}
                    </span>
                    {(selectedDrugId === original.orderid) && (
                        <IframeContainerDrug key={iframeKey} id={selectedDrugId} />
                    )}
                </div>
            )
        },
        {
            accessorKey: 'drugschedule',
            header: 'Drug Schedule',
            meta: {
                headerProps: { className: 'text-900' },
                // cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'generic',
            header: 'Generic',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        // {
        //     accessorKey: 'amount',
        //     header: 'Amount',
        //     meta: {
        //         headerProps: { className: 'text-900 text-start' },
        //         cellProps: { className: 'text-start' }
        //     }
        // },
        {
            accessorKey: 'dose',
            header: 'Dose',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'frequency',
            header: 'Frequency',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        // {
        //     accessorKey: 'route',
        //     header: 'Route',
        //     meta: {
        //         headerProps: { className: 'text-900 text-start' },
        //         cellProps: { className: 'text-start' }
        //     }
        // },
        // {
        //     accessorKey: 'discontinue',
        //     header: 'Disc Order',
        //     meta: {
        //         headerProps: { className: 'text-900 text-start' },
        //     },
        //     cell: ({ row: { original } }) => {
        //       return (
        //         <>
        //           {original.discontinued_date == null && localStorageAccessControl.includes(String(ACCESS_CONTROL["mym"])) ? (
        //             <Link className="p-2" onClick={() => {
        //               setSelectedDrugId(null);
        //               setShow(true);
        //             }} state={{ original }}>
        //               <FontAwesomeIcon icon="plus" className="me-1 fs-11" />
        //             </Link>
        //           ) : []}
        //         </>
        //       );
        //     }
        //   }

        // {
        //     accessorKey: 'refilldate',
        //     header: 'Refill Due',
        //     meta: {
        //         headerProps: { className: 'text-900 text-start' },
        //         cellProps: { className: 'text-start' }
        //     }
        // },
        // {
        //     accessorKey: '',
        //     header: 'Refill',
        //     meta: {
        //         headerProps: { className: 'text-900 text-start' },
        //         cellProps: { className: 'text-start' }
        //     },
        //     cell: ({ row: { original } }) => {
        //         return <div className="p-2" onClick={() => { localStorage.setItem("gridFormName", "lnkrefill," + original.orderid); setShowModal(true) }}>
        //             <FontAwesomeIcon icon="plus" className="me-1 fs-11" /></div>
        //     }
        // }
    ];

    // const isExpiredPrescription = stopDate => {
    //     if (!stopDate) return false;
    
    //     const parsedStopDate = moment(stopDate);
    //     return parsedStopDate.isValid() && parsedStopDate.isBefore(moment(), 'day');
    // };

    const getPrescriptionExpiryStatus = stopDate => {
    if (!stopDate) return null;

    const parsedStopDate = moment(stopDate);
    if (!parsedStopDate.isValid()) return null;

    const today = moment();
    const daysUntilExpiry = parsedStopDate.diff(today, 'days');

    if (parsedStopDate.isBefore(today, 'day')) {
        return { type: 'expired' };
    } else if (daysUntilExpiry <= 30) {
        return { type: 'expiring', daysLeft: daysUntilExpiry };
    }

    return null;
};
    // if (localStorageAccessControl.includes(String(ACCESS_CONTROL["mym"]))) {
    //     columns.push(discontinueColumn);
    // }

    const handleDrugClick = (drugId) => {
        setSelectedDrugId(drugId);
        setIframeKey(prev => prev + 1);
    };

    useEffect(() => {
        if (props.incomingPayload?.prefill) {
            setSelectedType(props.incomingPayload?.prefill?.selected);
        }
    }, [props.incomingPayload]);

    useEffect(() => {
        async function fetchAllPrescriptionData() {
            setSelectedDrugId(null);
            //console.log("props.patientid current " + props.patientid);

            setprescriptionTypeOptions([
                ...prescriptionType
            ]);

            let results = []

            //console.log("Prescription Data Status " + data.prescriptions.status);
            let objData = data.prescriptions;
            const twoDaysAgoStart = moment()
                .subtract(2, 'days')
                .startOf('day');


            const twoDaysAgoStartUTC = moment
                .utc()
                .subtract(2, 'days')
                .startOf('day');

            const discontinuedItems = objData.filter(
                el => el.discontinued_date != null
            );

            const discontinuedLast2Days = discontinuedItems.filter(el =>
                moment.utc(el.discontinued_date).isSameOrAfter(twoDaysAgoStartUTC)
            ).length;

            const unverifiedItems = objData.filter(
                el => el.is_verified == 0 && el.discontinued_date == null
            );

            // const unverifiedLast2Days = unverifiedItems.filter(el =>
            //     el.created_date &&
            //     moment(el.created_date).isSameOrAfter(twoDaysAgoStart)
            // ).length;

            const unverifiedLast2Days = unverifiedItems.filter(el =>
                el.created &&
                moment.utc(el.created).isSameOrAfter(twoDaysAgoStartUTC)
            ).length;

            setLegendCounts({
                active: objData.filter(el => el.discontinued_date == null).length,
                unverified: unverifiedItems.length,
                discontinued: discontinuedItems.length,
                discontinuedLast2Days,
                unverifiedLast2Days
            });


            let groupId = "";

            //console.log("prescriptionObjData" + JSON.stringify(objData));

            // localStorage.setItem("prescriptionObjData", JSON.stringify(objData));
            const existingData =
                JSON.parse(localStorage.getItem("patientid")) || {};

            // 🔹 Store prescriptions against patientId
            if (props.patientid) {
                existingData[props.patientid] = objData;
                localStorage.setItem("prescriptionObjData", JSON.stringify(existingData));
            }
            const filteredDiscontinued = objData.filter(el => el.discontinued_date != null);
            const filteredActive = (props.incomingPayload?.prefill?.selected == '' || props.incomingPayload?.prefill == null) ? objData.filter(el => el.discontinued_date == null) : objData.filter(element => element.is_verified == 0 && element.discontinued_date == null);
            filterPrescriptionData(action == "discontinued" ? filteredDiscontinued : filteredActive);
            // filterPrescriptionData(objData);
        }

        // Trigger the fetch
        fetchAllPrescriptionData();
    }, []);

    useEffect(() => {
        const observer = new MutationObserver(() => {
            const newTheme = document.documentElement.getAttribute('data-bs-theme');
            setTheme(newTheme);
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['data-bs-theme']
        });

        return () => observer.disconnect();
    }, []);

    const table = useAdvanceTable({
        data: currentPrescription,
        columns,
        selection: false,
        sortable: true,
        pagination: true
    });

    const handleFieldChange = e => {
        //console.log(e.target.value);
        setSelectedType(e.target.value);
        let prescriptionResults = JSON.parse(localStorage.getItem("prescriptionObjData"));
        prescriptionResults = prescriptionResults[props.patientid];
        console.log("prescriptionResults", prescriptionResults);
        let filtered_prescription = "";
        if (e.target.value == "") {
            filtered_prescription = prescriptionResults;
        }
        else if (e.target.value == "active")
            filtered_prescription = prescriptionResults.filter(element => element.discontinued_date == null)
        else if (e.target.value == "discontinued")
            filtered_prescription = prescriptionResults.filter(element => element.discontinued_date != null)
        // else if (e.target.value == "refill")
        //     filtered_prescription = prescriptionResults.filter(element => element.refill_date != null)
        else if (e.target.value == "unverified")
            filtered_prescription = prescriptionResults.filter(element => (element.is_verified == 0 && element.discontinued_date == null))

        filterPrescriptionData(filtered_prescription);
    }

    function filterPrescriptionData(filtered_prescription) {
        setSelectedDrugId(null);
        let results = [];
        const twoDaysAgoStart = moment()
            .utc()
            .subtract(2, 'days')
            .startOf('day');
        filtered_prescription.forEach((value) => {
            let stop_date = value.stop_date != null ? moment(value.stop_date, 'YYYY-MM-DD').format('MM/DD/YY') : null;
            let pharmacy_expire_date = value.pharmacy_expire_date != null ? moment(value.pharmacy_expire_date, 'YYYY-MM-DD').format('MM/DD/YY') : null;
            let start_date = value.start_date != null ? moment(value.start_date, 'YYYY-MM-DD').format('MM/DD/YY') : null;

            results.push({
                individual: props.data.last_name + ", " + props.data.first_name,
                facilityname: props.data.facility_name,
                orderid: value.id,
                hcp: value.doctor_lastname + ", " + value.doctor_firstname,
                drugText: `${value.drug} ${value.strength_value ?? ""} ${value.strength ?? ""}`.trim(),
                drug: `${value.drug} ${value.strength_value ?? ""} ${value.strength ?? ""}`.trim(),
                generic: value.generic,
                amount: value.amount,
                dose: value.dose,
                frequency: value.frequency,
                qty: value.qty,
                pharmacy_order_id: value.pharmacy_order_id,
                start: value.start_date,
                stop: value.stop_date,
                expiry: value.pharmacy_expire_date,
                facility_id: value.facility_id,
                patient_id: value.patient_id,
                ndc: value.drug_ndc,
                refilldate: value.refill_date != null ? moment(value.refill_date, 'YYYY-MM-DDThh:mm:ss').format('MM/DD/YY') : null,
                drug_form: value.drug_form,
                brand_drug: value.brand_drug,
                generic: value.generic,
                patient_name: props.username,
                earlytime: value.time_1,
                exceedtime: value.time_2,
                medstime: value.time_3,
                hourtime1: value.time_4,
                hourtime2: value.time_5,
                hourtime3: value.time_6,
                hourtime4: value.time_7,
                isvital: value.has_vitalsigns == null ? 0 : 1,
                patientid: props.patientid,
                is_verified: value.is_verified,
                route: value.route,
                discontinued_date: value.discontinued_date,
                from_ips: value.from_ips,
                med_type: value.med_type, // C -> cycle, P -> PRN, O -> other
                is_fnto: value.is_fnto,
                is_new: value.is_verified == 0 && value.discontinued_date == null && value.created &&
                    moment.utc(value.created).isSameOrAfter(twoDaysAgoStart) ? 1 : 0,
                created_date: value.created,
                drugschedule: [2, 3, 4, 5].includes(Number(value.drug_schedule))
                    ? `C${value.drug_schedule}`
                    : 'Not Controlled',
                client_stopdate: value.client_stopdate,
                // isExpired: isExpiredPrescription(value.client_stopdate),
                expiryStatus: getPrescriptionExpiryStatus(value.pharmacy_expire_date),
            });
        });

        // const medTypePriority = { 'C': 1, 'P': 2, 'O': 3, '': 4, null: 4, undefined: 4 };
        // setCurrentPrescription(
        //     results.sort((a, b) => {
        //         const priorityA = medTypePriority[a.med_type] ?? 5;
        //         const priorityB = medTypePriority[b.med_type] ?? 5;
        //         if (priorityA !== priorityB) {
        //             return priorityA - priorityB;
        //         }
        //         return a.drug.localeCompare(b.drug, 'en', { sensitivity: 'base' });
        //     })
        // );
        setCurrentPrescription(
            results.sort((a, b) =>
                a.drugText.localeCompare(b.drugText, 'en', { sensitivity: 'base' })
            )
        );
    }

    return (
        <div>
            {show && <DiscontinuePrescriptionModal show={show} setShow={setShow} data={data} />}
            <Row className="align-items-end mb-3">
                <Col md={3}>
                    <Form.Group>
                        <Form.Label>Prescription Type</Form.Label>
                        <Form.Select
                            name="prescriptiontype"
                            value={selectedType}
                            onChange={handleFieldChange}
                            size="sm"
                        >
                            {prescriptionTypeOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.key}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Col>
                {localStorageAccessControl.includes(String(ACCESS_CONTROL["editprescription"])) ? <Col md={6} className="d-flex flex-column mb-2">
                    <div className="d-flex flex-wrap align-items-center gap-4">
                        <div className="d-flex align-items-center gap-2">
                            <span
                                className="legend-active"
                                style={{ width: '25px', height: '25px', display: 'inline-block' }}
                            ></span>
                            <span className="fs-11 text-muted">
                                Active
                            </span>
                        </div>


                        <div className="d-flex align-items-center gap-1">
                            <span
                                className="legend-unverified rounded"
                                style={{ width: '25px', height: '25px', display: 'inline-block' }}
                            />
                            <small
                                className="text-muted"
                            >
                                Unverified
                            </small>
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id="tooltip-unverified-2days">
                                        New Prescriptions from past 48 hours
                                    </Tooltip>
                                }
                            >
                                <small
                                    className="text-muted cursor-pointer"
                                >
                                    ({legendCounts.unverifiedLast2Days})
                                </small>
                            </OverlayTrigger>
                        </div>


                        <div className="d-flex align-items-center gap-1">
                            <span
                                className="legend-discontinued rounded"
                                style={{ width: '25px', height: '25px', display: 'inline-block' }}
                            />
                            <small
                                className="text-muted"
                            >
                                Discontinued
                            </small>
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id="tooltip-discontinued-2days">
                                        Discontinued Prescriptions in past 48 hours
                                    </Tooltip>
                                }
                            >
                                <small
                                    className="text-muted cursor-pointer"
                                >
                                    ({legendCounts.discontinuedLast2Days})
                                </small>
                            </OverlayTrigger>
                        </div>


                    </div>
                </Col> : []}
                {currentPrescription.length > 0 && (
                    <Col md={3} className="d-flex justify-content-end align-items-end">
                        <AdvanceTableProvider {...table}>
                            <AdvanceTableSearchBox placeholder="Search..." />
                        </AdvanceTableProvider>
                    </Col>
                )}
            </Row>
            {currentPrescription.length > 0 ? (
                <AdvanceTableProvider {...table}>
                    <Row>
                        <Col>
                            <AdvanceTableCurrentPresc
                                headerClassName="bg-200 text-nowrap align-middle text-center"
                                rowClassName="text-nowrap align-middle text-center"
                                tableProps={{
                                    size: 'lg',
                                    striped: true,
                                    className: 'fs-10 mb-0'
                                }}
                            />
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col>
                            <AdvanceTableFooter rowInfo navButtons rowsPerPageSelection />
                        </Col>
                    </Row>
                </AdvanceTableProvider>
            ) : (
                <p className="text-danger text-center fw-bold">No data available in table</p>
            )}
        </div>
    );
};

export default CurrentPrescription;
